function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4836",
  "data-name": "Group 4836",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.79",
  height: "23.818"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2001",
  "data-name": "Rectangle 2001",
  fill: "#282828",
  d: "M0 0h22.79v23.818H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4769",
  "data-name": "Group 4769",
  clipPath: "url(#clip-path)",
  fill: "#282828"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2553",
  "data-name": "Path 2553",
  d: "M17.052 23.955a5.864 5.864 0 115.864-5.864 5.864 5.864 0 01-5.864 5.864m0-1.173a4.691 4.691 0 10-4.691-4.691 4.691 4.691 0 004.691 4.691m-.586-7.623h1.173v1.173h-1.174zm0 2.345h1.173v3.518h-1.174z",
  transform: "translate(-.125 -.137)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2554",
  "data-name": "Path 2554",
  d: "M14.355 10H3.467v1.3h9.555a7.815 7.815 0 011.333-.618z",
  transform: "translate(-.039 -.112)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2555",
  "data-name": "Path 2555",
  d: "M3.467 12.629v1.3h6.867a7.921 7.921 0 011.02-1.3z",
  transform: "translate(-.039 -.141)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2556",
  "data-name": "Path 2556",
  d: "M3.467 15.257v1.3h5.814a7.891 7.891 0 01.393-1.3z",
  transform: "translate(-.039 -.171)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2557",
  "data-name": "Path 2557",
  d: "M9.182 6.606a2.12 2.12 0 00-2.34 1.873h4.212a2.118 2.118 0 00-1.872-1.873",
  transform: "translate(-.077 -.074)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2558",
  "data-name": "Path 2558",
  d: "M9.093 17.8H1.979V1.978h9.887v3.955h3.955V10.2a7.828 7.828 0 011.105-.087 7.914 7.914 0 01.872.051v-5.22L12.854 0H.99A.988.988 0 000 .981V18.8a.989.989 0 00.982.981h8.325a7.844 7.844 0 01-.221-1.821c0-.052.006-.1.008-.156"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2559",
  "data-name": "Path 2559",
  d: "M8.959 5.854a1.177 1.177 0 001.176-1.178 1.178 1.178 0 10-1.176 1.178",
  transform: "translate(-.087 -.039)"
}))));